import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { LineFormControl } from "../Web/LineFormControl";
import { XStackContainer } from "../../Containers";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

function getUI(): { form: FormConfiguration; control: LineFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();
    const line = new LineFormControl();
    container.add(line);
    ui.add(container);

    return { form: ui, control: line };
}

export const LineControlStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.color = UIStyleConstants.GRAY_COLOR;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "Colored",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.color = UIStyleConstants.GRAY_COLOR;
            ui.control.height = 20;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "With Height",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.color = UIStyleConstants.GRAY_COLOR;
            ui.control.width = 200;
            ui.control.fullWidth = false;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "With Width",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.color = UIStyleConstants.GRAY_COLOR;
            ui.control.borderRadius = 5;
            ui.control.height = 10;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "With Border Radius",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.color = UIStyleConstants.GRAY_COLOR;
            ui.control.marginY = 30;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Line Control",
        "With Margin",
    ),
];
